module.exports = __webpack_public_path__ + "img/em-submetering-01.4852afab.jpg";